import { useEffect } from "react";

/** Keeps the phone's screen on while the story plays. Older phones just skip this. */
export function useScreenAwake(playing: boolean): void {
  useEffect(() => {
    if (!playing || !("wakeLock" in navigator)) {
      return;
    }
    let lock: WakeLockSentinel | null = null;
    let stopped = false;
    const acquire = (): void => {
      void navigator.wakeLock.request("screen").then((next) => {
        if (stopped) {
          void next.release();
        } else {
          lock = next;
        }
      }).catch(() => undefined);
    };
    // A phone drops the lock whenever the app leaves the screen.
    const onVisible = (): void => {
      if (document.visibilityState === "visible") {
        acquire();
      }
    };
    acquire();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      stopped = true;
      document.removeEventListener("visibilitychange", onVisible);
      void lock?.release().catch(() => undefined);
    };
  }, [playing]);
}
